import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionItem
} from "@heroui/react";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactApexChart from "react-apexcharts";

import { usePost } from "../../api/reactQueryCustomHooks.jsx";
import { apiRoute } from "../../constants/enum.js";
import { getMonthNamesBetween } from "../../Utility/utility.js";

// ✅ Month maps
// const monthNumberToName = {
//   1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun",
//   7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec",
// };

// const monthNameToNumber = {
//   jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6,
//   jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12,
// };

// ✅ FIXED month generator (max 12 months, no duplicate)
// const getMonthRange = (start, end) => {
//   const result = [];

//   let current = new Date(start);
//   const last = new Date(end);

//   current = new Date(current.getFullYear(), current.getMonth(), 1);
//   const endDate = new Date(last.getFullYear(), last.getMonth(), 1);

//   while (current <= endDate && result.length < 12) {
//     result.push(monthNumberToName[current.getMonth() + 1]);
//     current.setMonth(current.getMonth() + 1);
//   }

//   return result;
// };

const DashboardChart = ({ propDate }) => {
  const { compCode } = useSelector((state) => state.company);

  const [sale, setSale] = useState([]);
  const [purchase, setPurchase] = useState([]);
  const [chartXAxis, setChartXAxis] = useState([]);

  const { mutate: fetchSaleData } = usePost({
    url: apiRoute.dashboard.getTradingData,
    queryKey: "SaleChart",
    onSuccessTasks: (data) => setSale(data || []),
  });

  const { mutate: fetchPurchaseData } = usePost({
    url: apiRoute.dashboard.getTradingData,
    queryKey: "PurchaseChart",
    onSuccessTasks: (data) => setPurchase(data || []),
  });

 

  // ✅ optimized mapping (no find loop)
  // const buildChartData = (data, chartXAxis) => {
  //   const map = {};

  //   data.forEach((item) => {
  //     map[Number(item.Month)] = Number(item.Total_Value);
  //   });

  //   return chartXAxis.map((month) => {
  //     const id = monthNameToNumber[month.toLowerCase()];
  //     return map[id] || 0;
  //   });
  // };
 const normalize = (m) => m.toLowerCase().substring(0, 3);
  const buildChartData = (data, chartXAxis) => {
  const map = {};

  data.forEach((item) => {
    const key = `${item.Month}-${item.year}`;
    map[key] = Number(item.Total_Value);
  });

  
  return chartXAxis.map((monthYear) => {
    const [monthName, year] = monthYear.split("-");

    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };

    const key = `${monthMap[monthName]}-${year}`;

    return map[key] || 0;
  });
};


  const saleChart = useMemo(() => {
    return buildChartData(sale, chartXAxis);
  }, [sale, chartXAxis]);

  const purchaseChart = useMemo(() => {
    return buildChartData(purchase, chartXAxis);
  }, [purchase, chartXAxis]);

  const apexChartOptions = {
    chart: {
      type: "bar",
      stacked: false,
      width: "100%",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
      },
    },
    xaxis: {
      categories: chartXAxis,
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      labels: {
        formatter: (val) => val.toFixed(0),
      },
    },
    colors: ["#F9C80E", "#5653FE"],
    dataLabels: {
      enabled: false,
    },
  };


   useEffect(() => {
    // ✅ fixed month list
    // const months = getMonthRange(propDate.start, propDate.end);
    // setChartXAxis(months);
       const months = getMonthNamesBetween(propDate.start, propDate.end);
       
    setChartXAxis(months || []);

    const payload = {
      compcode: compCode.join(","),
      fromdate: propDate.start,
      todate: propDate.end,
    };

    fetchSaleData({ data: { ...payload, action: "Sale" } });
    fetchPurchaseData({ data: { ...payload, action: "Purchase" } });

  }, [propDate, compCode]);
  const apexChartSeries = [
    { name: "Purchase", data: purchaseChart },
    { name: "Sale", data: saleChart },
  ];

  // ✅ debug (remove later)
 
  if (!chartXAxis.length) {
    return <div>No data available</div>;
  }

  return (
    // <Accordion variant="splitted" defaultExpandedKeys={["1"]}>
    //   <AccordionItem
    //     key="1"
    //     title="Sales & Purchase"
    //     startContent={<FontAwesomeIcon icon={faChartColumn} />}
    //   >
        <div className="h-[70vh]">
          <div>
         <FontAwesomeIcon icon={faChartColumn}></FontAwesomeIcon>   Sales & Purchase
          </div>
          <ReactApexChart
            key={JSON.stringify(chartXAxis)} // ✅ force refresh fix
            options={apexChartOptions}
            series={apexChartSeries}
            type="bar"
            height="100%"
            width="100%"
          />
        </div>
    //   </AccordionItem>
    // </Accordion>
  );
};

export default DashboardChart;